import { atom } from 'jotai';
import { accessTokenState } from './access-token.js';
export const selectIsAccessTokenValid = atom((get) => {
    const accessToken = get(accessTokenState);
    return accessToken?.isValid;
});
//# sourceMappingURL=select-is-access-token-valid.js.map